module.exports = __webpack_public_path__ + "static/media/RIGHT.a5fe272e.svg";